<div
  class="operation-menus-small"
  [ngClass]="{'edit': isEditing, 'on-media-page': mediaPage}"
  id="actionMenuContainer"
>
  @for (operation of operationContainer.operations; track $index) {
    <ng-container>
      <button
        mat-button
        [matMenuTriggerFor]="operationMenu"
        class="operation-menus-small__button text-blue-hover"
        (click)="toggleOperation(operation)"
        #trigger="matMenuTrigger"
        [disabled]="isEditing || (rootObject.read_only && !operation.read_access) ||
        operation.$$disabled"
      >
        <i
          class="{{operation.menu_icon}}"
        ></i>

        <span>
          {{ operation.menu_title | translate }}
        </span>
      </button>

      <mat-menu #operationMenu="matMenu">
        <mat-accordion>
          @for (subOperation of operation.sub_operations; track $index) {
            <mat-expansion-panel
              #currentPanel
              (click)="openOperation(subOperation, operation, trigger); $event.stopPropagation()"
              (keydown)="null"
              [hideToggle]="!subOperation.sub_operations"
              [disabled]="!subOperation.sub_operations"
              [class.is-expanded]="currentPanel.expanded"
              [class.is-collapsed]="!currentPanel.expanded"
            >
              <mat-expansion-panel-header
                class="operation-menus-small__panel-header"
                [collapsedHeight]="'40px'"
                [expandedHeight]="'40px'"
              >
                <mat-panel-title>
                  @if (!subOperation.sub_operations) {
                    <i
                      class="{{subOperation.menu_icon}}"
                    ></i>
                  }

                  <span>
                    {{ subOperation.menu_title | translate }}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <mat-list>
                @for (subSubOperation of subOperation.sub_operations; track $index) {
                  <mat-list-item class="operation-menus-small__panel-content-item">
                    <button
                      (click)="openOperation(subSubOperation, operation, trigger)"
                      [disabled]="subSubOperation.$$disabled"
                      [title]="subSubOperation.$$toolTip"
                    >
                      <i
                        class="{{subSubOperation.menu_icon}}"
                      ></i>

                      <span>
                        {{ subSubOperation.menu_title | translate }}
                      </span>
                    </button>
                  </mat-list-item>
                }
              </mat-list>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </mat-menu>
    </ng-container>
  }
</div>
